import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PropertyUiModule } from '@classifieds-sell/property-ui';
import { APP_BASE_HREF } from '@angular/common';

import {
    TgBoxes2Module,
    TgIconSearchModule,
    TgIconBasicWarningFramedModule,
    TgTeleportModule,
    TgBadgeModule,
    TgRackModule,
    TangramModule
} from '@trademe/tangram';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ENVIRONMENT } from '@classifieds-sell/environment';
import { environment } from '../environments/environment';
import { AuthModule } from '@classifieds-sell/auth';
import { DatalayerModule } from '@classifieds-sell/datalayer';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationsModule } from 'libs/trademe-core-ui/src/lib/notifications/notifications.module';
import { NewRelicClientService } from 'libs/trademe-core-ui/src/lib/new-relic/new-relic-client.service';
import { NEW_RELIC_SERVICE_TOKEN } from 'libs/trademe-core-ui/src/lib/new-relic/new-relic-token';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        HammerModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NotificationsModule,
        TangramModule.forRoot(),
        TgBoxes2Module,
        TgIconSearchModule,
        TgIconBasicWarningFramedModule,
        TgTeleportModule,
        TgBadgeModule,
        TgRackModule,
        PropertyUiModule,
        DatalayerModule,
        AuthModule.forRoot(),
        StoreModule.forRoot(
            {},
            {
                metaReducers: !environment.production ? [] : [],
                runtimeChecks: {
                    strictActionImmutability: true,
                    strictStateImmutability: true
                }
            }
        ),
        EffectsModule.forRoot([]),
        !environment.production ? StoreDevtoolsModule.instrument({connectInZone: true}) : []
    ],
    exports: [],
    providers: [
        {
          provide: ENVIRONMENT,
          useValue: environment
        },
        {
            provide: APP_BASE_HREF,
            useValue: environment.appBaseHref
        },
        {
            provide: 'googleTagManagerId',
            useValue: environment.tagManagerId
        },
        { provide: NEW_RELIC_SERVICE_TOKEN, useClass: NewRelicClientService }

    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
